@if (question.answer; as answer) {
  <div [id]="question.id" class="grid">
    <div class="col pr-5">
      <p [innerHTML]="question.text | emMarkdown"></p>
      @if (question.subtexts; as subtexts) {
        @for (subtext of subtexts; track subtext; let last = $last) {
          @if (subtext.type === 'TEXT') {
            <p [innerHTML]="subtext.value | emMarkdown"></p>
          }
          @if (subtext.type === 'BULLET') {
            <li class="ml-8 list-disc leading-6">{{ subtext.value }}</li>
          }
        }
      }
    </div>
    @if (question.id === QUESTION_ID.WEIGHT) {
      <div class="col-1">
        @if (bmi) {
          <p class="text-center py-2 bg-blue-50 border-round-sm bmi"><strong i18n>IMC</strong>: {{ bmi }}</p>
        } @else {
          <p class="text-center py-2 bg-blue-50 border-round-sm"><strong i18n>IMC</strong>: N/A</p>
        }
      </div>
    }
    <div [class]="answer.inputType === 'TEXT_AREA' ? 'col-12' : 'col-3'">
      @switch (question.id) {
        @case (QUESTION_ID.WEIGHT) {
          <div class="grid p-0">
            <p-inputNumber
              class="col"
              [placeholder]="answer.placeholder ?? ''"
              [formControl]="control"></p-inputNumber>
            <p-selectButton
              class="col"
              [options]="WEIGHT_UNIT_OPTIONS"
              [allowEmpty]="false"
              [formControl]="extraControl!"
              optionLabel="text"
              optionValue="value"></p-selectButton>
          </div>
        }
        @default {
          <div class="col p-0">
            @switch (answer.type) {
              @case ('INPUT') {
                @if (answer.inputType === 'TEXT') {
                  <input
                    pInputText
                    [placeholder]="answer.placeholder ?? ''"
                    [formControl]="control"
                    type="text" />
                }
                @if (answer.inputType === 'TEXT_AREA') {
                  @if (control.enabled) {
                    <textarea
                      class="w-full"
                      pInputTextarea
                      [formControl]="control"
                      [maxlength]="5000"
                      [placeholder]="answer.placeholder ?? ''"
                      [rows]="answer.propertyName.endsWith('*') ? 10 : 4"></textarea>
                  }
                  @if (control.disabled) {
                    <p-card class="card__eq card__eq--disabled">
                      @if (control.value) {
                        <p class="opacity-50" [innerHTML]="control.value | emMarkdown"></p>
                      }
                      @if (!control.value) {
                        <p class="opacity-50">{{ answer.placeholder }}</p>
                      }
                    </p-card>
                  }
                }
                @if (answer.inputType === 'NUMBER') {
                  <p-inputNumber
                    [placeholder]="answer.placeholder ?? ''"
                    [formControl]="control"></p-inputNumber>
                }
                @if (answer.inputType === 'DATE') {
                  <input
                    i18n-placeholder
                    placeholder="JJ/MM/AAAA"
                    [formControl]="control"
                    mask="d0/M0/0000"
                    [dropSpecialCharacters]="false"
                    pInputText />
                }
              }
              @case ('DROPDOWN') {
                @if (answer.options) {
                  <p-dropdown
                    class="text-center"
                    [options]="answer.options"
                    [placeholder]="answer.placeholder ?? '--'"
                    [formControl]="control"
                    optionLabel="text"
                    optionValue="value"></p-dropdown>
                }
              }
              @case ('RADIO') {
                @if (answer.options) {
                  <p-dropdown
                    class="text-center"
                    [options]="answer.options"
                    [placeholder]="answer.placeholder ?? '--'"
                    [formControl]="control"
                    optionLabel="text"
                    optionValue="value">
                    <ng-template let-option pTemplate="item">
                      <span [innerHTML]="option.text | emMarkdown"></span>
                    </ng-template>
                    <ng-template let-selectedOption pTemplate="selectedItem">
                      <span [innerHTML]="selectedOption.text | emMarkdown"></span>
                    </ng-template>
                  </p-dropdown>
                }
              }
              @case ('YES_NO') {
                @if (answer.options) {
                  <p-selectButton
                    [options]="answer.options"
                    [allowEmpty]="false"
                    [formControl]="control"
                    optionLabel="text"
                    optionValue="value"></p-selectButton>
                }
              }
            }
          </div>
        }
      }
    </div>
  </div>
}
